import { AlgoliaAutocomplete } from "../Components/AlgoliaSearch/AlgoliaAutocomplete";

type Props = {
  searchWidth?: number;
};

export default function MenuBarSearch({ searchWidth }: Props) {
  return <AlgoliaAutocomplete searchWidth={searchWidth} />;
}
